import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Modal, Table, Loader} from 'semantic-ui-react';
import _ from 'lodash';
import {Actions} from '../../../../../common/actions';
import {
  renderTitle,
  renderTable,
} from '../../../../../common/util/partsUtils';

class StockModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'modalWasOpen': false,
    };
  }

  fetchData() {
    const {code} = this.props;
    this.props.fetchStockDetail(code);
    this.setState({'modalWasOpen': true});
  }

  renderData() {
    const {loading, stockDetail} = this.props;

    if (loading) {
      return (
        <Table.Body>
          <Table.Row active>
            <Table.Cell colSpan='100%'>
              <Loader active inline='centered' />
            </Table.Cell>
          </Table.Row>
        </Table.Body>
      );
    }
    return renderTable(stockDetail);
  }

  render() {
    const {quantity, loading, stockDetail} = this.props;
    const {modalWasOpen} = this.state;
    const numberAgencies = Object.keys(stockDetail).length;
    const existDataAfterCallApi = modalWasOpen && stockDetail;
    let totalStock = 0;
    Object.keys(stockDetail).forEach((agencyName) => {
      totalStock += _.sumBy(stockDetail[agencyName], 'stock');
    });

    if ((existDataAfterCallApi && totalStock === 0) || !quantity) {
      return <div>0</div>;
    }
    return (
      <Modal
        centered={false}
        size={Object.keys(stockDetail).length <= 2 ? 'small' : 'large'}
        onOpen={() => this.fetchData()}
        trigger={
          <div className='link'>
            {existDataAfterCallApi ? totalStock : quantity}
          </div>
        }
        closeIcon
      >
        <Modal.Header>
          Stock Nacional
          <span className='quantity-container'>
            {existDataAfterCallApi ? totalStock : quantity}
          </span>
        </Modal.Header>
        <Modal.Content scrolling>
          <Modal.Description>
            <Table striped className='toyota-grid'>
              <Table.Header>
                {!loading && numberAgencies > 0 && (
                  <Table.Row>{renderTitle(stockDetail)}</Table.Row>
                )}
              </Table.Header>

              {this.renderData(stockDetail)}
            </Table>
          </Modal.Description>
        </Modal.Content>
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.partModals.loadingStockDetail,
    'stockDetail': state.partModals.stockDetail,
  };
};

const {fetchStockDetail} = Actions;

export default connect(mapStateToProps, {
  fetchStockDetail,
})(StockModal);
